export enum PresignedUrlDestinations {
  // Explicit values: IntakeIngest (1) was removed with the legacy intake/bronze
  // pipeline, but ApplicationData must keep its on-the-wire value of 2.
  UserData = 0,
  ApplicationData = 2,
}

export const PROVIDER_AVATAR_FILE_PATH = "user/avatar/image.jpg";
